import { axios, baseURL } from "./axios.dashboard"


const SearchpolicyEnq = async (BType, enqType, value) => {
    return await axios
        .post(baseURL+"getPolicyEnq", {
            BType: BType,
            enqType: enqType,
            value: value
        })
        .then((response) => {
            return response
        }).catch((e) => {
            return e.response.data
    })
}

const SearchpolicyEnq_DET = async (value, BType) => {
    return await axios
        .post(baseURL+"getPolicyEnq/DET", {
            value: value,
            BType: BType
        })
        .then((response) => {
            return response
        }).catch((e) => {
            return e.response.data
    })
}

const SearchpolicyEnq_RIDER = async (value, BType) => {
    return await axios
        .post(baseURL+"getPolicyEnq/RIDER", {
            value: value,
            BType: BType
        })
        .then((response) => {
            return response
        }).catch((e) => {
            return e.response.data
    })
}

const SearchpolicyEnq_NOMINEE = async (value, BType) => {
    return await axios
        .post(baseURL+"getPolicyEnq/NOMINEE", {
            value: value,
            BType: BType
        })
        .then((response) => {
            return response
        }).catch((e) => {
            return e.response.data
    })
}

const SearchpolicyEnq_FUND = async (value, BType) => {
    return await axios
        .post(baseURL+"getPolicyEnq/FUND", {
            value: value,
            BType: BType
        })
        .then((response) => {
            return response
        }).catch((e) => {
            return e.response.data
    })
}

const SearchpolicyEnq_PREM = async (value, BType) => {
    return await axios 
        .post(baseURL+"getPolicyEnq/PREM", {
            value: value,
            BType: BType
        })
        .then((response) => {
            return response
        }).catch((e) => {
            return e.response.data
        })
}

export { SearchpolicyEnq, SearchpolicyEnq_DET, SearchpolicyEnq_RIDER, SearchpolicyEnq_NOMINEE, SearchpolicyEnq_FUND, SearchpolicyEnq_PREM }